import { motion } from 'framer-motion'

import { styled } from 'styled-system/jsx'

const StyledButton = styled(motion.button, {
  base: {
    fontFamily: 'body',
    fontWeight: '600',
    borderRadius: 'pill',
    border: 'none',
    cursor: 'pointer',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '8px',
    transition:
      'transform {durations.fast} {easings.appleStandard}, box-shadow {durations.fast} {easings.appleStandard}, background-color {durations.fast} {easings.appleStandard}, border-color {durations.fast} {easings.appleStandard}',
    _disabled: {
      opacity: '0.55',
      cursor: 'not-allowed',
      transform: 'none',
      boxShadow: 'none',
    },
  },
  variants: {
    variant: {
      primary: {
        backgroundColor: 'quickpass.primary',
        color: '#FFFFFF',
        boxShadow: '0 6px 20px -8px rgba(128, 84, 255, 0.55)',
      },
      secondary: {
        backgroundColor: 'quickpass.surface',
        color: 'quickpass.ink',
        border: '1.5px solid',
        borderColor: '#E5E0F5',
      },
      ghost: {
        backgroundColor: 'transparent',
        color: 'quickpass.primary',
      },
    },
    size: {
      small: {
        fontSize: '13px',
        paddingX: '14px',
        paddingY: '8px',
        minHeight: '36px',
      },
      medium: {
        fontSize: '15px',
        paddingX: '20px',
        paddingY: '11px',
        minHeight: '44px',
      },
      large: {
        fontSize: '16px',
        paddingX: '24px',
        paddingY: '14px',
        minHeight: '52px',
      },
    },
    isFullWidth: {
      true: {
        width: '100%',
      },
    },
  },
  defaultVariants: {
    variant: 'primary',
    size: 'medium',
  },
})

export { StyledButton }
